import { HTTPClient, propsToDate, propsToDatePaged } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { DateHelper } from '@abaco/web-components/src/components/DateUtils';
import axios, { CancelTokenSource } from "axios";
import { Warehouse, WarehouseOut, WarehouseType, StockedItem, StockedItemOut, StockedItemLoadOut, WarehouseUpdateOut } from '../models/Warehouse';
import { UnitOfMeasure, UnitOfMeaseureFamily } from '../models/UnitsOfMeasure';
import { parseDeclaredArea } from './utils';
import { Traceability } from '../models/Traceability';

export default class TraceabilityApi {

    private http: HTTPClient;
    private rootPath: string;
    private cancelTokenSource: CancelTokenSource | null;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
        this.cancelTokenSource = null;
    }


    public async getTraceabilitySetting(): Promise<string> {
        const res = await this.http.get(`${this.rootPath}/v1/traceability/settings`);
        return res.data.version;
    }

    public async downloadTraceability(lotId: string): Promise<string> {
        const res = await this.http.get(`${this.rootPath}/v1/traceability/production_lot/${lotId}/xml?traceability_tree=all`);
        return res.data;
    }

    public async getTraceabilities(lotId: string): Promise<Traceability[]> {
        const res = await this.http.get(`${this.rootPath}/v1/traceability/production_lot/${lotId}?traceability_tree=all`);
        return res.data;
    }

}
